import { ResolvedFilterBarProps } from './types';

export function useFilterBar(props: ResolvedFilterBarProps) {
  const {
    filterAssignee,
    filterType,
    filterStatus,
    filterPriority,
    showDependencies,
    hideEmptyDays,
    datePadding,
    showCompleted,
    showArchived,
    showTaskDetails,
    onFilterAssignee,
    onFilterType,
    onFilterStatus,
    onFilterPriority,
    onShowDependencies,
    onHideEmptyDays,
    onDatePadding,
    onToggleShowCompleted,
    onToggleShowArchived,
    onToggleShowTaskDetails
  } = props;

  const isAnyFilterActive = (
    filterAssignee !== 'all' ||
    filterType !== 'all' ||
    filterStatus !== 'all' ||
    filterPriority !== 'all' ||
    !showDependencies ||
    hideEmptyDays ||
    datePadding !== 3 ||
    showCompleted ||
    showArchived ||
    !showTaskDetails
  );

  const handleResetFilters = () => {
    onFilterAssignee('all');
    onFilterType('all');
    onFilterStatus('all');
    onFilterPriority('all');
    onShowDependencies(true);
    onHideEmptyDays(false);
    onDatePadding(3);
    onToggleShowCompleted(false);
    onToggleShowArchived(false);
    onToggleShowTaskDetails(true);
  };

  return {
    isAnyFilterActive,
    handleResetFilters
  };
}
